import { render, staticRenderFns } from "./miscellaneousDialog.vue?vue&type=template&id=352d5ef2&scoped=true"
import script from "./miscellaneousDialog.vue?vue&type=script&lang=js"
export * from "./miscellaneousDialog.vue?vue&type=script&lang=js"
import style0 from "./miscellaneousDialog.vue?vue&type=style&index=0&id=352d5ef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352d5ef2",
  null
  
)

export default component.exports